/**
 * 사용자에게 그대로 보여줄 의도로 우리가 직접 작성한 오류.
 *
 * 서버 액션 래퍼(src/server/action-error.ts의 guarded)는 **UserError의 메시지만**
 * 클라이언트로 내보낸다. 그 외 오류(DB 드라이버, fetch, JSON 파싱 등 우리가 문구를
 * 통제하지 않는 것들)는 일반 문구로 대체된다 — 드라이버 오류 문자열에는 제약조건
 * 이름이나 파라미터 값 같은 내부 정보가 섞여 들어올 수 있기 때문이다
 * (tests/unit/expense-actions.test.ts의 SENSITIVE_DRIVER_ERROR 회귀 테스트 참고).
 *
 * 즉 기본값은 "내보내지 않음"이다. 새 검증 문구를 추가할 때 Error로 던지면
 * 사용자에게는 일반 문구가 보일 뿐 정보가 새지는 않는다.
 */
export class UserError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UserError";
  }
}
